<template>
  <div class="flex items-center gap-2 text-base py-5">
    <button
      class="text-text-2 flex items-center gap-1 hover:text-text-1"
      @click="handleBack"
    >
      <Icon
        icon="sky:ic-left"
        class="size-5"
      />
      <span>{{ prevTitle }}</span>
    </button>
    <span>/</span>
    <span class="text-text-1">{{ title }}</span>
  </div>
</template>

<script setup lang="ts">
const props = withDefaults(defineProps<{
  prevTitle: string
  title: string
}>(), {
  prevTitle: '',
  title: '',
})
const emit = defineEmits<{
  (e: 'back'): void
}>()

const handleBack = () => {
  emit('back')
}

</script>
